/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppSchemasOfferFloorOut
 */
export interface AppSchemasOfferFloorOut {
    /**
     * 
     * @type {number}
     * @memberof AppSchemasOfferFloorOut
     */
    attributeId: number;
}

export function AppSchemasOfferFloorOutFromJSON(json: any): AppSchemasOfferFloorOut {
    return AppSchemasOfferFloorOutFromJSONTyped(json, false);
}

export function AppSchemasOfferFloorOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppSchemasOfferFloorOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attributeId': json['attributeId'],
    };
}

export function AppSchemasOfferFloorOutToJSON(value?: AppSchemasOfferFloorOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attributeId': value.attributeId,
    };
}


